/** One phrase per line: edge spaces removed, empty lines dropped, duplicates dropped keeping the first. */
const normalizeSpeechPhrases = (text: string): string[] => {
	const phrases = text
		.split('\n')
		.map((line) => line.trim())
		.filter((line) => line !== '');

	return [...new Set(phrases)];
};

export default normalizeSpeechPhrases;
